module.exports = __webpack_public_path__ + "static/index/img/baikal-404.aca1c63a.jpg";